const app = angular
  .module('landingPage')
  .controller('FmaTrackingController', ($scope, $document, $window) => {
    $scope.fmaInfo = '';

    $scope.init = (fmaInfo) => {
      if (fmaInfo) {
        $scope.fmaInfo = fmaInfo.replace(/\s/g, '').toLowerCase();
        $document.safeReady(() => {
          $window.tracking_data.merchandising_units =
            'home_fma_' + $scope.fmaInfo + '-shown';
        });
      }
    };
  });
